import React from 'react';
import PropTypes from 'prop-types';

export default class PluginConfiguration extends React.Component {

    static propTypes = {
        configuration: PropTypes.object,
        enableSave: PropTypes.func.isRequired,
        disableSave: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.enableSave();
    }

    getConfiguration() {
        return null;
    }

    render() {
        return null;
    }
};



// WEBPACK FOOTER //
// ./src/components/plugins/commentsPlugin/PluginConfiguration.js